module.exports = __webpack_public_path__ + "static/media/29EUNOG18.194816b6.jpg";